<template>
	<b-form-select
		v-model="selected"
		:options="options"
		:class="{'smaller': smaller}"
		@input="$emit('input', $event)"
		@change="$emit('change', $event)"
	>
		<template #first>
			<b-form-select-option :value="emptyValue" disabled>{{ emptyValueLabel }}</b-form-select-option>
		</template>
	</b-form-select>
</template>

<script>
export default {

	props: {
		options: {
			type: Array,
			required: true,
		},
		value: {
			required: false,
		},
		emptyValue: {
			required: false,
			default: undefined,
		},
		emptyValueLabel: {
			type: String,
			required: false,
			default: '--- Bitte triff eine Auswahl ---',
		},
		smaller: {
			type: Boolean,
			required: false,
			default: false,
		}
	},

	data ()
	{
		return {
			selected: this.value !== this.emptyValue ? this.value : this.emptyValue,
		};
	},

	watch: {
		value (v)
		{
			this.selected = v;
		},
	}
}
</script>
